import { render } from "./Route.vue?vue&type=template&id=774038f4&scoped=true"
import script from "./Route.vue?vue&type=script&lang=js"
export * from "./Route.vue?vue&type=script&lang=js"

import "./Route.vue?vue&type=style&index=0&id=774038f4&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774038f4"]])

export default __exports__